import { Canvas } from 'glsl-canvas-js';

class LambdaShaders
{
    static CurrentShaders = [];

    static loadShaders()
    {
        this.waitForShaderScroll();
    }

    static waitForShaderScroll()
    {
        let observer = new IntersectionObserver((entries, observer) => {

            entries.forEach(entry => {

                if(entry.isIntersecting)
                {
                    console.log("Creating shader", entry.target.id);
                    this.setupShader(entry.target);
                }
                else
                {
                    if(this.CurrentShaders[entry.target.id])
                    {
                        this.CurrentShaders[entry.target.id].destroy();
                        delete this.CurrentShaders[entry.target.id];
                        console.log("Destroyed shader", entry.target.id);
                    }
                }

            });

        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        });

        document.querySelectorAll('.lambda-shader').forEach((element) => {
            observer.observe(element);
        });
    }

    static setupShader(elem)
    {
        var shaderCode = elem.getAttribute("data-shader-code");
        var shaderUrl = elem.getAttribute("data-shader-url");
        var materialData = elem.getAttribute("data-material-data");
        var jMatData = JSON.parse(materialData);

        var render = new Canvas(elem, {
            vertexString: null,
            fragmentString: shaderCode,
            onError: (err) => { console.error(err); },
        });

        let i = 0;

        jMatData.Materials.forEach((mat) => {

            let samplerName = `u_texture_${i}`;

            render.setTexture(samplerName, mat.RenderPath);

            i++;

        });

        this.CurrentShaders[elem.id] = render;

    }
}

export default LambdaShaders;